export default __webpack_public_path__ + "388848740e9860394d4f690d99b8fae4.png";